var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagineLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "122.8px",
    height: "26.2px",
    viewBox: "0 0 122.8 26.2",
    style: {
      enableBackground: "new 0 0 122.8 26.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#929497;}\n\t.st2{fill:#626366;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,14.9L42.5,0.6c-0.2-0.3-0.6-0.3-0.7,0l-8.3,14.3c-0.2,0.3,0,0.6,0.4,0.6h16.5 C50.7,15.5,50.9,15.2,50.8,14.9 M36.6,13.5l5.5-9.6l5.5,9.6H36.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.5,11.9 45,2.3 50.5,11.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.2,
    className: "st0",
    width: 2.1,
    height: 15.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.9,15.5 25.8,15.5 24.8,3.4 24.7,3.4 20,15.6 18.8,15.6 14.2,3.4 14.1,3.4 13.1,15.5 11,15.5  12.4,0.2 15,0.2 19.4,12 19.5,12 23.9,0.2 26.5,0.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.2,13.3c-0.3,0.3-2.1,2.5-6.5,2.5c-4.4,0-7.8-3.1-7.8-7.9C56,3.1,59.4,0,63.7,0c3.9,0,5.6,2.1,6.2,2.6 L68.4,4c-0.9-1.1-2.3-2.2-4.7-2.2c-3.1,0-5.5,2.3-5.5,6c0,3.8,2.5,6,5.7,6c3.2,0,4.3-1.4,4.3-1.4V9.1H64V7.3h6.2V13.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 0.2,
    className: "st0",
    width: 2.1,
    height: 15.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,15.5H102L93.3,3.3c0,0,0,2.1,0,4v8.1h-2.1V0.2h2.3l8.6,12c0,0,0-1.9,0-3.9V0.2h2.1V15.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "122.8,15.5 113.7,15.5 113.7,0.2 122.6,0.2 122.6,2 115.8,2 115.8,6.6 122.2,6.6 122.2,8.3 115.8,8.3  115.8,13.6 122.8,13.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.9,25.4c-0.3,0.4-0.9,0.8-1.9,0.8c-1.5,0-2.7-1.1-2.7-2.7c0-1.6,1.2-2.7,2.7-2.7c1,0,1.6,0.4,1.9,0.7 l-0.3,0.6c-0.2-0.3-0.8-0.6-1.5-0.6c-1.1,0-1.9,0.8-1.9,2c0,1.2,0.8,2,1.9,2c0.7,0,1.2-0.3,1.6-0.6L83.9,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.7,26.1h-0.8l-0.5-1.4h-2.2l-0.5,1.4h-0.8l2.1-5.2h0.6L91.7,26.1z M90.1,24.1l-0.9-2.3l-0.9,2.3H90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.4,26.1h-0.7l-3-4.2c0,0,0,0.7,0,1.4v2.8H95v-5.2h0.8l3,4.1c0,0,0-0.6,0-1.3v-2.8h0.7V26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,26.1h-0.8l-0.5-1.4H104l-0.5,1.4h-0.8l2.1-5.2h0.6L107.6,26.1z M106.1,24.1l-0.9-2.3l-0.9,2.3H106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.4,25.4c-0.4,0.3-1,0.7-1.9,0.7h-1.6v-5.2h1.6c0.9,0,1.6,0.3,1.9,0.7c0.4,0.3,0.8,1,0.8,1.9 C115.2,24.5,114.8,25.1,114.4,25.4 M113.9,22c-0.3-0.3-0.8-0.5-1.4-0.5h-0.8v4h0.8c0.6,0,1.1-0.2,1.4-0.5c0.3-0.3,0.6-0.7,0.6-1.5 C114.5,22.7,114.2,22.3,113.9,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,26.1h-0.8l-0.5-1.4h-2.2l-0.5,1.4h-0.8l2.1-5.2h0.6L123,26.1z M121.4,24.1l-0.9-2.3l-0.9,2.3H121.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.3,3.6 43.1,5.6 46.7,11.9 49.1,11.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagineLogoMobile);
export default __webpack_public_path__ + "static/media/imagine-logo-mobile.664b883b1f3a71da1f2e4213750ae9cb.svg";
export { ForwardRef as ReactComponent };